import React from 'react';
import {
    Form, Row, Col, Input, Select, Button, InputNumber, Layout, DatePicker, message, Icon, Modal, Radio
} from 'antd';
import MiCompAPI from "../../../util/api";
import moment from "moment";
import img from '../../../assets/img/At the office-pana 1.png';
import AddBORT from '../../Administration/BOR/AddBORT';
const { Content } = Layout;
const { Option } = Select;
class ETP extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            client_id: this.props.location.state["client_id"],
            lob: [],
            UOM: [],
            remib_type: [],
            Profile: [""],
            Commission_Process: [],
            bors: [],
            Tier: null,
            eBOR: null,
            visible: false,
            vis: null
        }
        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    handleSubmit = (e) => {
        
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                var input = [];
                const { keys, tier_profile_id, profile_tier1, profile_tier2, profile_tier3, profile_tier4, profile_tier5, profile_tier6,
                    profile_tier7, profile_tier8, profile_tier9, profile_tier10, tier_profile_name, profile_start_date, profile_end_date
                    , min_allow, max_allow, qualifier_value, new_add_renewal, reimb_type_id, reimb_cal_meth, isProrated, isLSPayment } = values;
                
                keys.map((z, i) => {
                    input.push({
                        tier_profile_id: tier_profile_id[i] ? tier_profile_id[i] : 0,
                        profile_tier1: profile_tier1[i],
                        profile_tier2: profile_tier2[i],
                        profile_tier3: profile_tier3[i],
                        profile_tier4: profile_tier4[i],
                        profile_tier5: profile_tier5[i],
                        profile_tier6: profile_tier6[i],
                        profile_tier7: profile_tier7[i],
                        profile_tier8: profile_tier8[i],
                        profile_tier9: profile_tier9[i],
                        profile_tier10: profile_tier10[i],
                        tier_profile_name: tier_profile_name[i],
                        profile_start_date: profile_start_date[i]&&new Date(profile_start_date[i]).toDateString(),
                        profile_end_date: profile_end_date[i]&&new Date(profile_end_date[i]).toDateString(),
                        min_allow: min_allow[i],
                        max_allow: max_allow[i],
                        qualifier_value: qualifier_value[i],
                        new_add_renewal: new_add_renewal[i],
                        reimb_type_id: reimb_type_id[i],
                        reimb_cal_meth: reimb_cal_meth[i],
                        isLSPayment: isLSPayment && isLSPayment[i],
                        isProrated: isProrated && isProrated[i],
                    });
                    return "";
                });
                this.api.invoke(
                    "SavenAndEditClient_Tier",
                    "post",
                    (data, success) => {
                        if (success) {
                            if (data.statusCode === 200) {
                                message.destroy();
                                message.success(data.statusMessage, 3);
                                this.props.history.push({
                                    pathname: '/myplans',
                                    state: { client_id: this.state.client_id }
                                });
                            } else {
                                message.destroy();
                                message.error(data.statusMessage, 3);
                            }
                        }
                    }, { ...values,start_date:values.start_date&&new Date(values.start_date).toDateString(),end_date:values.end_date&&new Date(values.end_date).toDateString(), client_Tier_ProfileViews: input, client_id: this.state.client_id, tier_id: this.props.location.state["tier_id"] }
                );
            }
        });
    }
    remove = k => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        if (keys.length === 1) {
            return;
        }
        form.setFieldsValue({
            keys: keys.filter(key => key !== k),
        });
    };
    add = () => {
        const { form } = this.props;
        const keys = form.getFieldValue('keys');
        const nextKeys = keys.concat(key => key++);
        form.setFieldsValue({
            keys: nextKeys,
        });
    };
    getClientMasters() {
        this.api.invoke(
            "GetMasters",
            "post",
            (data, success) => {
                if (success) {
                    this.setState({
                        lob: data.lobs,
                        UOM: data.uom_type,
                        remib_type: data.remib_type,
                        Commission_Process: data.commission_process,
                        bors: data.bors
                    });
                }
            },
            ["LOB", "UOM_TYPE", "TEMIB_TYPE", "COMMISSION_PRPCESS", "BOR"]
        );
    }

    closeHandler = () => {
        this.setState({ visible: false });
    };

    onChanges = (e) => {
        this.api.invoke("GetAllBORbyid/" + e, "get", (data, status) => {
            if (status) {
                if (data.statusCode === 200) {

                    this.setState({
                        visible: true,
                        eBOR: data.data,
                    })
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    };


    componentDidMount = () => {
        const { setFieldsValue } = this.props.form;
        this.getClientMasters();
        if (this.props.location.state["tier_id"] !== 0) {
            this.api.invoke(
                "GetClient_TierById/" + this.props.location.state["tier_id"],
                "get",
                (data, success) => {
                    if (success) {
                        if (data.statusCode === 200) {
                            var { Tier, Profile } = data.data;
                            this.setState({
                                Profile: Profile,
                                Tier: Tier
                            })
                            setTimeout(() => {
                                setFieldsValue({
                                    client_id: Tier.client_id,
                                    tier1: Tier.tier1,
                                    tier2: Tier.tier2,
                                    tier3: Tier.tier3,
                                    tier4: Tier.tier4,
                                    tier5: Tier.tier5,
                                    tier6: Tier.tier6,
                                    tier7: Tier.tier7,
                                    tier8: Tier.tier8,
                                    tier9: Tier.tier9,
                                    tier10: Tier.tier10,
                                    start_date: moment(new Date(Tier.start_date)),
                                    end_date: moment(new Date(Tier.end_date)),
                                    uom_id: Tier.uom_id,
                                    is_rate: Tier.is_rate,
                                    client_plan_Id: Tier.client_plan_Id,
                                    plan_Name: Tier.plan_Name,
                                    lob: Tier.lob,
                                    plan_type_id: Tier.plan_type_id,
                                    commission_Process: Tier.commission_Process,
                                    commission_Recovery_Period: Tier.commission_Recovery_Period,
                                    bor: Tier.bor,


                                });
                            }, 300);
                        } else {
                            message.destroy();
                            message.error(data.statusMessage, 3);
                        }
                    }
                });
        }
    }
    render() {

        const { getFieldDecorator, getFieldValue } = this.props.form;
        const { lob, UOM, remib_type, Profile, Commission_Process, bors, Tier } = this.state;
        getFieldDecorator('keys', { initialValue: Profile ? Profile : [""] });
        const keys = getFieldValue('keys');
        const formItems = keys ? keys.map((k, index) => (
            <Row key={index} span={24}>
                <Row md={24}>
                    <Col md={6} sm={24}>
                        <Form.Item style={{ display: "none" }} required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Profile Id</legend>
                                {getFieldDecorator(`tier_profile_id[${index}]`, {
                                    initialValue: k.tier_profile_id,

                                })(<Input autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Profile Id *' />
                                )}
                            </fieldset>
                        </Form.Item>
                        <Form.Item required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Profile Name</legend>
                                {getFieldDecorator(`tier_profile_name[${index}]`, {
                                    initialValue: k.tier_profile_name,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please enter Profile Name.",
                                        },
                                    ],
                                })(<Input autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Profile Name *' />
                                )}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Qualifier Value</legend>
                                {getFieldDecorator(`qualifier_value[${index}]`, {
                                    initialValue: k.qualifier_value,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please enter Qualifier Value.",
                                        },
                                    ],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Qualifier Value *' />
                                )}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Start Date</legend>
                                {getFieldDecorator(`profile_start_date[${index}]`, {
                                    initialValue: k.start_date ? moment(new Date(k.start_date)) : null,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please enter Start Date.",
                                        },
                                        {
                                            validator(rule, value) {
                                                if (!value || ((new Date(new Date(getFieldValue(`start_date`)).toDateString())) <= new Date(new Date(value).toDateString()) && new Date(new Date(getFieldValue(`end_date`)).toDateString()) >= new Date(new Date(value).toDateString()))) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Profile Start date must be in between Plan Start Date and End Date');
                                            }
                                        }
                                    ],
                                })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" placeholder='Plese Select Start Date *' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">End Date</legend>
                                {getFieldDecorator(`profile_end_date[${index}]`, {
                                    initialValue: k.end_date ? moment(new Date(k.end_date)) : null,
                                    rules: [
                                        {
                                            required: false,
                                            message: "Please enter End Date.",
                                        },
                                        {
                                            validator(rule, value) {
                                                if (!value || getFieldValue(`profile_start_date[${index}]`) <= value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('End date must be greater than Start Date');
                                            }
                                        },
                                        {
                                            validator(rule, value) {
                                                if (!value || (new Date(new Date(getFieldValue(`start_date`)).toDateString()) <= new Date(new Date(value).toDateString()) && new Date(new Date(getFieldValue(`end_date`)).toDateString()) >= new Date(new Date(value).toDateString()))) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject('Profile End date must be in between Plan Start Date and End Date');
                                            }
                                        }
                                    ],
                                })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" placeholder='Plese Select End Date' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row>
                <Row md={24}>
                    <Col md={6} sm={24}>
                        <Form.Item required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Minimum Allow</legend>
                                {getFieldDecorator(`min_allow[${index}]`, {
                                    initialValue: k.min_allow,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please enter Minimum Allow.",
                                        },
                                    ],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Minimum Allow *' />
                                )}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Maximum Allow</legend>
                                {getFieldDecorator(`max_allow[${index}]`, {
                                    initialValue: k.max_allow,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please enter Maximum Allow.",
                                        },
                                    ],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Maximum Allow *' />
                                )}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item
                            required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Reimbursement Type</legend>
                                {getFieldDecorator(`reimb_type_id[${index}]`, {
                                    initialValue: k.reimb_type_id,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please select Reimbursement Type.",
                                        },
                                    ],
                                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                    placeholder="Please Select Reimbursement Type *">
                                    {remib_type.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                                </Select>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item
                            required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Calculation Method</legend>
                                {getFieldDecorator(`reimb_cal_meth[${index}]`, {
                                    initialValue: k.reimb_cal_meth,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please select Calculation Method.",
                                        },
                                    ],
                                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                    placeholder="Please Select Calculation Method">
                                    <Option value={true} key={true}>Percentage</Option>
                                    <Option value={false} key={false}>Fixed</Option>
                                </Select>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row>
                <Row md={24}>
                    <Col md={6} sm={24}>
                        <Form.Item
                            required={false}
                        >
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Profile Type</legend>
                                {getFieldDecorator(`new_add_renewal[${index}]`, {
                                    initialValue: k.new_add_renewal,
                                    rules: [
                                        {
                                            required: true,
                                            message: "Please select Profile Type.",
                                        },
                                    ],
                                })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                    placeholder="Please Select Is New Profile">
                                    <Option value={true} key={true}>New</Option>
                                    <Option value={false} key={false}>Renewal</Option>
                                </Select>)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    {getFieldValue(`new_add_renewal[${index}]`) && <>
                        <Col md={6} sm={24}>
                            <Form.Item>
                                <fieldset className="mi_input_pop">
                                    <legend className="legend-font">Lump Sum Amount</legend>
                                    {getFieldDecorator(`isLSPayment[${index}]`, {
                                        initialValue: k.isLSPayment || false,
                                        rules: [{ required: true, message: 'Please select Lump Sum Amount' }],
                                    })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                        optionFilterProp="children"
                                        showSearch={true}
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        placeholder="Please Select Lump Sum Amount ">
                                        <Option value={true} key={true}>Yes</Option>
                                        <Option value={false} key={false}>No</Option>
                                    </Select>)}
                                </fieldset>
                            </Form.Item>
                        </Col>
                        {getFieldValue(`isLSPayment[${index}]`) &&
                            <Col md={6} sm={24}>
                                <Form.Item
                                    required={true}
                                >
                                    <fieldset className="mi_input_pop">
                                        <legend className="legend-font">Pro Rated</legend>
                                        {getFieldDecorator(`isProrated[${index}]`, {
                                            initialValue: k.isProrated || false, rules: [{ required: true, message: 'Please select Pro Rated' }],
                                        })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                            optionFilterProp="children"
                                            showSearch={true}
                                            filterOption={(input, option) =>
                                                option.props.children
                                                    .toLowerCase()
                                                    .indexOf(input.toLowerCase()) >= 0
                                            }
                                            placeholder="Please Select Pro Rated ">
                                            <Option value={true} key={true}>Yes</Option>
                                            <Option value={false} key={false}>No</Option>
                                        </Select>)}
                                    </fieldset>
                                </Form.Item>
                            </Col>}</>}

                </Row>
                <Row>
                <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font" id="number">Tier 1</legend>
                                {getFieldDecorator(`profile_tier1[${index}]`, {
                                    initialValue: k.tier1,
                                    rules: [{ required: false, message: 'Please enter Tier 1' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier1')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 1');
                                        }
                                    },],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 1' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 2</legend>
                                {getFieldDecorator(`profile_tier2[${index}]`, {
                                    initialValue: k.tier2,
                                    rules: [{ required: false, message: 'Please enter Tier 2' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier2')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 2');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 2' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 3</legend>
                                {getFieldDecorator(`profile_tier3[${index}]`, {
                                    initialValue: k.tier3,
                                    rules: [{ required: false, message: 'Please enter Tier 3' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier3')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 3');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 3' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>

                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 4</legend>
                                {getFieldDecorator(`profile_tier4[${index}]`, {
                                    initialValue: k.tier4,
                                    rules: [{ required: false, message: 'Please enter Tier 4' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier4')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 4');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 4' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 5</legend>
                                {getFieldDecorator(`profile_tier5[${index}]`, {
                                    initialValue: k.tier5,
                                    rules: [{ required: false, message: 'Please enter Tier 5' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier5')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 5');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 5' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 6</legend>
                                {getFieldDecorator(`profile_tier6[${index}]`, {
                                    initialValue: k.tier6,
                                    rules: [{ required: false, message: 'Please enter Tier 6' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier6')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 6');
                                        }
                                    }],
                                })(<Input autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 6' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 7</legend>
                                {getFieldDecorator(`profile_tier7[${index}]`, {
                                    initialValue: k.tier7,
                                    rules: [{ required: false, message: 'Please enter Tier 7' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier7')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 7');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 7' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 8</legend>
                                {getFieldDecorator(`profile_tier8[${index}]`, {
                                    initialValue: k.tier8,
                                    rules: [{ required: false, message: 'Please enter Tier 8' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier8')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 8');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 8' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>

                </Row>
                <Row>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 9</legend>
                                {getFieldDecorator(`profile_tier9[${index}]`, {
                                    initialValue: k.tier9,
                                    rules: [{ required: false, message: 'Please enter Tier 9' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier9')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 9');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 9' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        <Form.Item>
                            <fieldset className="mi_input_pop">
                                <legend className="legend-font">Tier 10</legend>
                                {getFieldDecorator(`profile_tier10[${index}]`, {
                                    initialValue: k.tier10,
                                    rules: [{ required: false, message: 'Please enter Tier 10' },
                                    {
                                        validator(rule, value) {
                                            if (value || !getFieldValue('tier10')) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject('Please enter Tier 10');
                                        }
                                    }],
                                })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 10' />)}
                            </fieldset>
                        </Form.Item>
                    </Col>
                    <Col md={6} sm={24}>
                        {keys.length > 1 ? (
                            <i className="fa fa-2x fa-minus-circle" style={{ marginTop: '44px', float: 'right' }}
                                onClick={() => this.remove(k)}
                                aria-hidden="true"></i>
                        ) : null}
                    </Col>
                </Row>
            </Row >
        )) : "";
        return (
            <Content>
                <div className="mi_main_div">
                    <div className="mi_box_sd">
                        <Row span={24}>
                            <Col span={18}>
                                <h4 className="mi_box_h4">{this.props.location.state["tier_id"] !== 0 ? "Edit Plan and Profile" : "Add Plan and Profile"}</h4>
                            </Col>
                            <Col span={6}>
                                <img alt="example" style={{ height: '150px', marginTop: '-50px' }} src={img} />
                            </Col>
                        </Row>
                    </div>
                    <div className="mi_main">
                        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
                            <Row>
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Plan Id</legend>
                                            {getFieldDecorator('client_plan_Id', {
                                                rules: [{ required: true, message: 'Please enter Plan Id' }, {
                                                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s()]+$/,
                                                    message: "It allows only Alphanumerics"
                                                }],
                                            })(<Input autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Plan Id *' />)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Plan Name</legend>
                                            {getFieldDecorator('plan_Name', {
                                                rules: [{ required: true, message: 'Please enter Plan Name' }, {
                                                    pattern: /^(?!\s)(?![\s\S]*\s$)[A-Za-z0-9\s()]+$/,
                                                    message: "It allows only Alphanumerics"
                                                }],
                                            })(<Input autoComplete={"nope"} className="mi_input" type="text" placeholder='Enter Plan Name *' />)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Start Date</legend>
                                            {getFieldDecorator('start_date', {
                                                rules: [{ required: true, message: 'Please enter Start Date' }],
                                            })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" placeholder='Plese Select Start Date *' />)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">End Date</legend>
                                            {getFieldDecorator('end_date', {
                                                rules: [{ required: false, message: 'Please enter End Date' },
                                                {
                                                    validator(rule, value) {
                                                        if (!value || new Date(new Date(getFieldValue('start_date')).toDateString()) <= new Date(new Date(value).toDateString())) {
                                                            return Promise.resolve();
                                                        }
                                                        return Promise.reject('End date must be greater than Start Date');
                                                    }
                                                }],
                                            })(<DatePicker autoComplete={"nope"} format="MM/DD/YYYY" className="mi_input" placeholder='Plese Select End Date' />)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row >
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">LOA</legend>
                                            {getFieldDecorator('lob', {
                                                rules: [{ required: true, message: 'Please select LOA' }],
                                            })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                optionFilterProp="children"
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                placeholder="Please Select LOA *">
                                                {lob.map(tag => <Option value={tag.name} key={tag.name}>{tag.name}</Option>)}
                                            </Select>)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Unit of Measurement</legend>
                                            {getFieldDecorator('uom_id', {
                                                rules: [{ required: true, message: 'Please select Unit of Measurement' }],
                                            })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                optionFilterProp="children"
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                placeholder="Please Select Unit of Measurement *">
                                                {UOM.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                                            </Select>)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Rate</legend>
                                            {getFieldDecorator('is_rate', {
                                                rules: [{ required: true, message: 'Please select Rate' }],
                                            })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                optionFilterProp="children"
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                placeholder="Please Select IsRate ">
                                                <Option value={true} key={true}>Yes</Option>
                                                <Option value={false} key={false}>No</Option>
                                            </Select>)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>

                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Commission Process</legend>
                                            {getFieldDecorator(`commission_Process`, {
                                                rules: [{ required: true, message: 'Please select Commission Process' }],
                                            })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                optionFilterProp="children"
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                placeholder="Please Select Commission Process *">
                                                {Commission_Process.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}                                                   
                                                </Option>)}
                                            </Select>)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>
                                </Row>
                                <Row>

                                <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Commission Recovery Period </legend>
                                            {getFieldDecorator(`commission_Recovery_Period`, {
                                                rules: [
                                                    {
                                                        required: false,
                                                        message: 'Please enter Commission Recovery Period '
                                                    },
                                                ],
                                            })(<InputNumber disabled={getFieldValue("commission_Process")!==1} autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Commission Recovery Period ' />)}
                                        </fieldset>
                                    </Form.Item>
                                </Col>

                                {/* <Col md={6} sm={24}>
                                    <Form.Item>
                                        <fieldset className="mi_input_pop">
                                            <legend className="legend-font">Broker of Record</legend>
                                            {getFieldDecorator("bor", {
                                                rules: [{
                                                    required: false,
                                                    message: 'Please select Broker of Record'
                                                }],
                                            })(<Select suffixIcon={<Icon style={{ transform: 'rotate(90deg)' }} type="double-right" />} className="mi_input"
                                                optionFilterProp="children"
                                                showSearch={true}
                                                filterOption={(input, option) =>
                                                    option.props.children
                                                        .toLowerCase()
                                                        .indexOf(input.toLowerCase()) >= 0
                                                }
                                                placeholder="Please Select Broker of Record"
                                                onChange={this.onChanges}
                                            >
                                                {bors.map(tag => <Option value={tag.id} key={tag.id}>{tag.name}</Option>)}
                                            </Select>)}
                                        </fieldset>
                                    </Form.Item>
                                </Col> */}
                            </Row>
                            <Row span={24}>
                                <Modal visible={this.state.visible} >
                                    <div className="mi_model_popup">
                                        <Row span={24}>
                                            <Col span={24}>
                                                <p style={{ textAlign: "center" }} className="mi_title">
                                                    Rules
                                                </p>
                                            </Col>
                                            <Col >
                                                {this.state.eBOR &&
                                                    this.state.eBOR.rules.map((x, index) => {
                                                        return <div style={{ margin: '0px 13px' }}><Row style={{ margin: '0px' }}>
                                                            <Col md={18} sm={24}   >
                                                                <Form.Item>
                                                                    {x.key}</Form.Item>
                                                            </Col>
                                                            <Col md={6} sm={24}  >
                                                                <Form.Item>
                                                                    {x.val ?
                                                                        <span style={{ fontWeight: 'bold' }}>: Applicable</span> :
                                                                        <span style={{ fontWeight: 'bold' }}>: Not Applicable</span>
                                                                    }                                                                </Form.Item>
                                                            </Col></Row> </div>
                                                    })}
                                            </Col>
                                        </Row>
                                        <Row span={24} style={{ marginTop: "30px" }}>
                                            <Col span={7}></Col>
                                            <Col span={5}>
                                                <Button
                                                    className="mi_button_right submit-button"
                                                    onClick={this.closeHandler}
                                                    style={{ marginRight: 8 }}
                                                >
                                                    Close
                                                </Button>
                                            </Col>
                                            <Col span={7}>
                                                <img
                                                    alt="example"
                                                    style={{
                                                        height: "70px",
                                                        marginBottom: "-30px",
                                                        float: "right",
                                                    }}
                                                    src={img}
                                                />
                                            </Col>
                                            <Col span={7}></Col>
                                        </Row>
                                    </div>
                                </Modal>
                                <></>
                            </Row>
                            <Row>
                                <Col md={24} sm={24}>
                                    <h2 style={{ marginLeft: '15px' }}> <b>Tiers</b></h2>
                                </Col>
                                <Col md={24} sm={24}>
                                    <Row>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 1</legend>
                                                    {getFieldDecorator('tier1', {
                                                        rules: [{ required: true, message: 'Please enter Tier 1' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 1 *' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 2</legend>
                                                    {getFieldDecorator('tier2', {
                                                        rules: [{ required: false, message: 'Please enter Tier 2' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 2' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 3</legend>
                                                    {getFieldDecorator('tier3', {
                                                        rules: [{ required: false, message: 'Please enter Tier 3' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 3' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 4</legend>
                                                    {getFieldDecorator('tier4', {
                                                        rules: [{ required: false, message: 'Please enter Tier 4' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 4' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                    </Row><Row>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 5</legend>
                                                    {getFieldDecorator('tier5', {
                                                        rules: [{ required: false, message: 'Please enter Tier 5' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 5' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 6</legend>
                                                    {getFieldDecorator('tier6', {
                                                        rules: [{ required: false, message: 'Please enter Tier 6' }],
                                                    })(<Input autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 6' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 7</legend>
                                                    {getFieldDecorator('tier7', {
                                                        rules: [{ required: false, message: 'Please enter Tier 7' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 7' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 8</legend>
                                                    {getFieldDecorator('tier8', {
                                                        rules: [{ required: false, message: 'Please enter Tier 8' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 8' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                    </Row><Row>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 9</legend>
                                                    {getFieldDecorator('tier9', {
                                                        rules: [{ required: false, message: 'Please enter Tier 9' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 9' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                        <Col md={6} sm={24}>
                                            <Form.Item>
                                                <fieldset className="mi_input_pop">
                                                    <legend className="legend-font">Tier 10</legend>
                                                    {getFieldDecorator('tier10', {
                                                        rules: [{ required: false, message: 'Please enter Tier 10' }],
                                                    })(<InputNumber autoComplete={"nope"} className="mi_input" type="number" placeholder='Enter Tier 10' />)}
                                                </fieldset>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row>
                                <Col s={24}>
                                    <h2 style={{ marginLeft: '15px' }}><b>Profiles</b></h2>
                                    {formItems}
                                    <Form.Item >
                                        <Button type="dashed" onClick={this.add} style={{ width: '100%' }}>
                                            <i className="fa fa-plus" aria-hidden="true"></i> Add Profile
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Button className="mi_button_right submit-button" type="primary" htmlType="submit">
                                    Save
                                </Button>{" "}
                                <Button className="mi_button_right submit-button"

                                    onClick={() => {
                                        this.props.history.push({
                                            pathname: '/myplans',
                                        });
                                    }}
                                >
                                    Back
                                </Button>
                            </Row>
                        </Form>
                    </div>
                </div>
            </Content>)
    }
}
const AddTierandProfile = Form.create()(ETP);
export default AddTierandProfile;